import Vue from 'vue'
import Router from 'vue-router'

import Cint from '../pages/cint.vue'
import Instant from '../pages/instant';
import Cash from '../pages/cash';
import Point from '../pages/point';
import Login from '../pages/login';
import Profile from '../pages/profile';
import Follow from '../pages/follow';
import Award from '../pages/award';
import EndPage from '../pages/endpage';
import NotFound from '../pages/notFound';
import Failure from '../pages/failure';
import ErrorPage from '../pages/errorPage';
import Channel from '../pages/channel'
import ChannelDetail from '../pages/channeldetail'
import ChannelOut from '../pages/channelout'
import ChannelDetailOut from '../pages/channeldetailout'
import Privacy from '../pages/privacy';
import Policy from '../pages/policy';
import User from '../pages/user';
import Register from '../pages/register';
import Open from '../pages/open';
import axios from 'axios';

import { getCookie, isLogin } from '../utils';

Vue.use(Router)

const router = new Router({
    routes: [
        { path: '/', name: '首页', component: Cint, meta: { requiresAuth: true } },
        { path: '/instant', name: '即付问卷', component: Instant, meta: { requiresAuth: true } },
        { path: '/cash', name: '现金问卷', component: Cash, meta: { requiresAuth: true } },
        { path: '/point', name: '点子问卷', component: Point, meta: { requiresAuth: true } },
        { path: '/follow', name: '关注公众号', component: Follow, meta: { requiresAuth: false } },
        { path: '/channel', name: '渠道回答', component: Channel, meta: { requiresAuth: true } },
        { path: '/channel/detail', name: '提现详情', component: ChannelDetail, meta: { requiresAuth: true } },
        { path: '/channel/out', name: '渠道回答', component: ChannelOut },
        { path: '/channel/detail/out', name: '提现详情', component: ChannelDetailOut },
        { path: '/login', name: '扫码登录', component: Login, meta: { requiresAuth: false } },
        { path: '/award', name: '恭喜页', component: Award, meta: { requiresAuth: true } },
        { path: '/profile', name: '用户页', component: Profile, meta: { requiresAuth: true } },
        { path: '/endpage', name: '结果页', component: EndPage },
        { path: '/failure', name: '失败页', component: Failure },
        { path: '/error', name: '错误页', component: ErrorPage },
        { path: '/privacy', name: '隐私政策', component: Privacy },
        { path: '/policy', name: '隐私政策', component: Policy },
        { path: '/user', name: '用户协议', component: User },
        { path: '/register', name: '绑定手机号', component: Register, meta: { requiresAuth: false } },
        { path: '/open', name: '开通卖点子', component: Open, meta: { requiresAuth: false } },
        { path: '/404', name: '404', component: NotFound },
        { path: '*', name: '404', component: NotFound }
    ]
})

// 判断是否注册，未注册跳转
router.beforeEach((to, from, next) => {
    // 开发环境直接放行
    // if (process.env.NODE_ENV === 'development') {
    //     next()
    //     return
    // }
    // eslint-disable-next-line
    console.log(`--- to.path = ${to.path}`)
    if (to.path.indexOf('beian.miit.gov.cn') != -1) {
        // eslint-disable-next-line
        console.log(`放行`);
        next();
        return;
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (isLogin()) {
            // eslint-disable-next-line
            console.log(`--- 已登录`)
                // 判断是否绑定过手机号
            let unionId = getCookie('unionId');
            axios.get(`https://home.51point.com/51point-0.0.1-SNAPSHOT/mdz/ck?param=${unionId}`)
                .then(res => {
                    console.log(`---- ck`)
                    console.log(res)
                    if (res.data.code == 1 && res.data.data.ib == 1) {
                        // 已绑定手机号，判断是否开通卖点子
                        axios.get(`https://home.51point.com/51point-0.0.1-SNAPSHOT/miniMdz/isLogin?unionID=${unionId}`)
                            .then(res => {
                                console.log(`--- miniMdz/isLogin`)
                                console.log(res)
                                if (res.data.count == 0) {
                                    // 没开通
                                    next({ path: '/open' })
                                } else {
                                    // 已开通
                                    next();
                                }
                            })
                    } else {
                        // 没绑定手机号
                        next({ path: '/register' })
                    }
                })
                .catch(() => {
                    // 没绑定手机号
                    next({ path: '/register' })
                })
        } else {
            // eslint-disable-next-line
            console.log(`--- 未登录`)
            next({ path: '/login' })
        }
    } else {
        // eslint-disable-next-line
        console.log(`--- 不需要登录`)
        next();
    }
})


export default router